import { createSlice, CaseReducer, PayloadAction } from '@reduxjs/toolkit';

import { get, post } from 'api/requests';

import { DONE } from 'consts';

import { AppThunk } from 'store/types';
import { IParamsReq } from 'types';
import { DefectsStore, DefectData, SubmitDefectParams } from 'features/Defects/types';

const initialState: DefectsStore = {
  loading: false,
  count: 0,
  list: [],
};

const reset: CaseReducer<DefectsStore> = () => initialState;

const loading: CaseReducer<DefectsStore, PayloadAction<boolean>> = (state, action) => {
  state.loading = action.payload;
};

const list: CaseReducer<DefectsStore, PayloadAction<DefectData[]>> = (state, action) => {
  state.list = action.payload;
};

const count: CaseReducer<DefectsStore, PayloadAction<number>> = (state, action) => {
  state.count = action.payload;
};

export const defectsSlice = createSlice({
  name: 'defects',
  initialState,
  reducers: {
    reset,
    loading,
    list,
    count,
  },
});

const {
  reset: setReset,
  loading: setLoading,
  list: setCurrentDefects,
  count: setDefectsCount,
} = defectsSlice.actions;

export const setDefects =
  (defects: DefectData[]): AppThunk =>
  dispatch => {
    dispatch(setCurrentDefects(defects));
  };

export const getDefects =
  (params: IParamsReq): AppThunk =>
  dispatch => {
    dispatch(setLoading(true));
    get<DefectsType>('/api/issues/', params)
      .then(({ data }) => {
        const { results, count } = data;
        dispatch(setDefects(results));
        dispatch(setDefectsCount(count));
      })
      .finally(() => dispatch(setLoading(false)));
  };

export const getEngineeringDefects =
  (params: IParamsReq): AppThunk =>
  dispatch => {
    dispatch(setLoading(true));
    get<DefectsType>('/api/issues/en/', params)
      .then(({ data }) => {
        const { results, count } = data;
        /* TODO что это и зачем */
        dispatch(
          setDefects(
            results
              ? results.map(item => ({ ...item, title: item.title?.split(' - ')[2] }))
              : results,
          ),
        );
        dispatch(setDefectsCount(count));
      })
      .finally(() => dispatch(setLoading(false)));
  };

export const postDefectAccept =
  (params: IParamsReq, id: number, type?: string): AppThunk =>
  dispatch => {
    dispatch(setLoading(true));
    const url = type ? `/api/issues/${type}/${id}/set_done/` : `/api/issues/${id}/set_done/`;

    post(url)
      // TODO type
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .then<any, DefectData>(({ data }) => {
        const { status } = data;
        if (status === DONE) {
          dispatch(type ? getEngineeringDefects(params) : getDefects(params));
        }
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

export const postSubmitDefectRevision =
  (id: number, data: SubmitDefectParams, search: IParamsReq): AppThunk =>
  dispatch => {
    dispatch(setLoading(true));
    post(`/api/issues/${id}/set_todo/`, data)
      .then(() => {
        dispatch(getDefects(search));
      })
      .finally(() => dispatch(setLoading(false)));
  };

/* TODO переписать функцию без дублирования кода */
export const postSubmitDefectRevisionEngineering =
  (id: number, reqData: SubmitDefectParams, search: IParamsReq): AppThunk =>
  dispatch => {
    dispatch(setLoading(true));
    post(`/api/issues/en/${id}/set_todo/`, reqData)
      .then(() => {
        dispatch(getEngineeringDefects(search));
      })
      .finally(() => dispatch(setLoading(false)));
  };

export const sendExcelInEmail = (isApartments: boolean, reqData: IParamsReq): void => {
  const url = isApartments ? '/api/issues/generate_report/' : '/api/issues/en/generate_report/';
  post(url, reqData);
};

export { setReset };

type DefectsType = {
  results: DefectData[];
  count: number;
};
